import { render, staticRenderFns } from "./BtnSalvarCliente.vue?vue&type=template&id=58863e3c&"
import script from "./BtnSalvarCliente.vue?vue&type=script&lang=js&"
export * from "./BtnSalvarCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports